import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingFallback from '../LoadingFallback';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, isAdminSession } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingFallback />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (!isAdminSession()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
